// colors.ts
export const colors = {
  white: '#FFFFFF',           // Branco
  lightWhite: '#F5F5F5',      // Branco leve
  primary: '#6E30E8',         // Primária
  primaryLight80: 'rgba(136, 128, 212, 0.8)',  // Primária Leve - 80%
  primaryLight50: 'rgba(136, 128, 212, 0.5)',  // Primária Leve - 50%
  primaryLight40: 'rgba(136, 128, 212, 0.4)',  // Primária Leve - 40%
  lightPrimary: '#8880D4',    // Primária Leve
  secondary: '#00D6D6',       // Secundária
  darkGrey: '#1B1B1B',        // Cinza escuro
  darkGrey2: '#313131',       // Cinza escuro - 2
  darkGrey3: '#4D4D4D',       // Cinza escuro - 3
  darkGrey4: '#666666',       // Cinza escuro - 4
  lightGrey: '#999999',       // Cinza claro
  alert: '#FF0000',           // Alerta
};
